import get from 'lodash/get';

export const selectLogoDestinationUrl = state =>
  get(state, 'account.online_ordering_general_settings.logo_destination_url');
